import { DateTimeProps, GenericDateTime } from "components/Form/components/GenericDateTime/GenericDateTime";

export const DateTime = (props: DateTimeProps) => (
    <GenericDateTime
        {...props}
        type="datetime-local"
    />
);